import React from "react";
import { Person, SmartToy } from "@mui/icons-material";
import { Avatar, Box, styled } from "@mui/material";
import { MessageSender } from "../../../interfaces/all";

const AvatarContainer = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  marginRight: "4px",
  marginLeft: "4px",
});

interface MessageAvatarProps {
  sentBy: MessageSender;
  showAvatar: boolean;
}

const MessageAvatar: React.FC<MessageAvatarProps> = ({
  sentBy,
  showAvatar,
}) => {
  const getAvatarContent = () => {
    switch (sentBy) {
      case "user":
        return <SmartToy />;
      case "client":
        return <Person />;
      default:
        return null;
    }
  };

  const getAvatarColor = () => {
    switch (sentBy) {
      case "user":
        return "#00a884"; // Verde do WhatsApp
      case "client":
        return "#54656f"; // Cinza do WhatsApp
      default:
        return "#8696a0"; // Cinza claro
    }
  };

  return (
    <AvatarContainer>
      {showAvatar ? (
        <Avatar
          sx={{
            width: 36,
            height: 36,
            bgcolor: getAvatarColor(),
            color: "#fff",
            display: "flex",
            transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
            willChange: "transform",
            "&:hover": {
              transform: "scale(1.1) rotate(5deg)",
            },
          }}
        >
          {getAvatarContent()}
        </Avatar>
      ) : (
        <Box sx={{ width: 36, height: 36 }} /> // Elemento vazio que mantém o espaço
      )}
    </AvatarContainer>
  );
};

export default MessageAvatar;
